import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { MachinesService } from '../services/machines.service';

@Component({
  selector: 'ngx-edit-machine',
  templateUrl: './edit-machine.component.html',
  styleUrls: ['./edit-machine.component.scss'],
})
export class EditMachineComponent implements OnInit {
  @Input() stationId: string;
  @Input() equipment: any;
  linearMode = true;

  constructor(
    private ref: NbDialogRef<EditMachineComponent>,
    private machineService: MachinesService,
  ) { }

  ngOnInit() {
  }

  close() {
    this.ref.close();
  }

  async editMachine() {
    const [error] = await this.machineService.updateEquipment(this.stationId, this.equipment);
    // tslint:disable-next-line: max-line-length
    if (error) return this.alert('Ocurrio un error al intentar actualizar la información, intenta más tarde por favor', 'error');
    this.alert('Equipo actualizado con éxito');
    this.ref.close(true);
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
